import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import './NoticeRow.css'

export interface NoticeItem {
  id: string
  title: ReactNode
  text?: ReactNode
  /** Canal y hora, p. ej. "Hoy, 10:12 · WhatsApp" */
  meta: ReactNode
  unread?: boolean
  onClick?: () => void
}

export interface NoticeListProps {
  items: NoticeItem[]
  className?: string
}

/** Fila de aviso (bundle B7): punto de no leído de 10 px en primary + título + texto + meta con canal y hora. */
export function NoticeRow({ title, text, meta, unread, onClick }: Omit<NoticeItem, 'id'>) {
  const { t } = useTranslation()
  const body = (
    <>
      <span className={cx('hp-notice__dot', unread && 'hp-notice__dot--on')} aria-hidden="true" />
      <div className="hp-notice__body">
        <div className="hp-notice__title">
          {unread && <span className="visually-hidden">{t('v2.ds.notice.noLeido')} · </span>}
          {title}
        </div>
        {text && <div className="hp-notice__text">{text}</div>}
        <div className="hp-notice__meta tnum">{meta}</div>
      </div>
    </>
  )
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="hp-notice hp-notice--clickable">
        {body}
      </button>
    )
  }
  return <div className="hp-notice">{body}</div>
}

export function NoticeList({ items, className }: NoticeListProps) {
  return (
    <ul className={cx('hp-notices', className)}>
      {items.map(({ id, ...rest }) => (
        <li key={id} className="hp-notices__item">
          <NoticeRow {...rest} />
        </li>
      ))}
    </ul>
  )
}
